
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface ConditionOperatorSelectProps {
  value: string;
  onValueChange: (value: string) => void;
}

const OPERATOR_OPTIONS = [
  { value: 'only_contains', label: 'Include' },
  { value: 'does_not_contain', label: 'Exclude' },
];

export const ConditionOperatorSelect = ({ value, onValueChange }: ConditionOperatorSelectProps) => {
  const hasSelection = Boolean(value);
  
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger 
        className={`h-7 w-auto min-w-[120px] text-sm ${
          !hasSelection ? 'border-red-500 text-red-600' : ''
        }`}
      >
        <SelectValue placeholder="Select an option" />
      </SelectTrigger>
      <SelectContent>
        {OPERATOR_OPTIONS.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
